import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const features = ['Rider-Waite', 'Tarot de Marsella', 'Interpretación Profesional', 'Tarot Evolutivo', 'Material práctico', 'Formación completa'];
export function WhyDifferent() {
  return <section className="py-20 relative z-10" data-id="element-213">
      <div className="container mx-auto px-4" data-id="element-214">
        <motion.div initial={{
        y: 20
      }} whileInView={{
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-215">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-216">
            ¿Por qué esta formación es diferente?
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-217"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-218">
          {features.map((feature, i) => <motion.div key={i} initial={{
          y: 20
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-mystic-800/80 border border-gold/20 p-6 rounded-xl flex items-center gap-4" data-id="element-219">
              <div className="w-8 h-8 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0" data-id="element-220">
                <Check size={16} className="text-gold" data-id="element-221" />
              </div>
              <span className="font-medium text-white/90" data-id="element-222">{feature}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}